'use client';
import React from 'react';

const airlines = [
  { name: 'American Airlines', code: 'AA', deal: 'Deals from $129' },
  { name: 'Delta Air Lines', code: 'DL', deal: 'Deals from $139' },
  { name: 'United Airlines', code: 'UA', deal: 'Save up to 25%' },
  { name: 'Southwest Airlines', code: 'WN', deal: 'Deals from $89' },
  { name: 'JetBlue Airways', code: 'B6', deal: 'Deals from $99' },
  { name: 'Alaska Airlines', code: 'AS', deal: 'Deals from $119' },
  { name: 'Spirit Airlines', code: 'NK', deal: 'Fares from $49' },
  { name: 'Frontier Airlines', code: 'F9', deal: 'Fares from $39' },
  { name: 'Air Canada', code: 'AC', deal: 'Deals from $189' },
  { name: 'British Airways', code: 'BA', deal: 'Deals from $429' },
  { name: 'Air France', code: 'AF', deal: 'Deals from $459' },
  { name: 'Lufthansa', code: 'LH', deal: 'Deals from $479' },
  { name: 'Emirates', code: 'EK', deal: 'Special Fares' },
  { name: 'Turkish Airlines', code: 'TK', deal: 'Deals from $519' },
  { name: 'Hawaiian Airlines', code: 'HA', deal: 'Deals from $229' },
  { name: 'Copa Airlines', code: 'CM', deal: 'Deals from $279' },
];

const AIRLINE_COLORS: Record<string, string> = {
  AA: '#0078D2',
  DL: '#E01933',
  UA: '#005DAA',
  WN: '#304CB2',
  B6: '#003876',
  AS: '#01426A',
  NK: '#FFD700',
  F9: '#00A651',
  AC: '#F01428',
  BA: '#075AAA',
  AF: '#002157',
  LH: '#05164D',
  EK: '#C69214',
  TK: '#C8102E',
  HA: '#4B0082',
  CM: '#005DAA',
};

export default function AirlinesSection() {
  const row1Airlines = [...airlines, ...airlines];
  const row2Airlines = [...airlines.slice().reverse(), ...airlines.slice().reverse()];

  return (
    <div className="py-24 bg-slate-50 overflow-hidden relative border-b border-slate-100">
      {/* Luxury Editorial Header Block */}
      <div className="max-w-[1170px] mx-auto px-4 mb-16 text-center relative z-10">
        <div
          style={{ height: '30px' }}
          className="inline-flex items-center gap-1.5 bg-accent/10 border border-accent/25 px-3.5 py-1.2 rounded-full text-[10px] font-black text-accent uppercase tracking-widest mb-4 shadow-sm"
        >
          TRUSTED GLOBAL PARTNERS
        </div>
        <h2 className="text-3xl md:text-[38px] font-extrabold text-slate-900 tracking-tight leading-none mb-4 uppercase">
          Flight Deals from 500+ Airlines
        </h2>
        <p className="text-slate-500 mt-3 max-w-2xl mx-auto text-xs md:text-sm font-semibold leading-relaxed">
          Fly with top-rated carriers around the globe. We partner directly with leading airlines to
          unlock dynamic wholesale ticketing relationships and unpublished phone-only airfares.
        </p>
      </div>

      {/* Marquee Viewport Container */}
      <div className="relative w-full flex flex-col gap-9">
        {/* Soft edge gradient fades perfectly blended into background */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-56 bg-gradient-to-r from-slate-50 via-slate-50/70 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-56 bg-gradient-to-l from-slate-50 via-slate-50/70 to-transparent z-10 pointer-events-none" />

        {/* Row 1: Right to Left (RTL) */}
        <div className="overflow-hidden w-full">
          <div
            className="flex gap-16 md:gap-20 items-center animate-marquee-rtl"
            style={{ width: 'max-content' }}
          >
            {row1Airlines.map((airline, i) => {
              return (
                <div
                  key={`row1-${i}`}
                  className="flex-shrink-0 w-32 h-14 flex items-center justify-center transition-all duration-300 hover:scale-108 select-none cursor-pointer group"
                >
                  <img
                    src={`https://pics.avs.io/200/80/${airline.code}@2x.png`}
                    alt={airline.name}
                    className="h-9 md:h-11 w-auto object-contain mix-blend-multiply opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              );
            })}
          </div>
        </div>

        {/* Row 2: Left to Right (LTR) */}
        <div className="overflow-hidden w-full">
          <div
            className="flex gap-16 md:gap-20 items-center animate-marquee-ltr"
            style={{ width: 'max-content' }}
          >
            {row2Airlines.map((airline, i) => {
              return (
                <div
                  key={`row2-${i}`}
                  className="flex-shrink-0 w-32 h-14 flex items-center justify-center transition-all duration-300 hover:scale-108 select-none cursor-pointer group"
                >
                  <img
                    src={`https://pics.avs.io/200/80/${airline.code}@2x.png`}
                    alt={airline.name}
                    className="h-9 md:h-11 w-auto object-contain mix-blend-multiply opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
